<button
  (click)="clicked.emit()"
  [class.big]="big()"
  [class.small]="small()"
  [disabled]="disabled()"
  [matTooltipPosition]="tooltipPosition()"
  [matTooltip]="tooltip()"
  [type]="type()"
  [class]="buttonStyle()"
  matIconButton
>
  <ui-icon
    [animation]="currentAnimationName()"
    [faName]="currentIconName()"
    [faStyle]="currentIconStyle()"
    [matBadgeSize]="badgeSize()"
    [matBadge]="badge() || ''"
  ></ui-icon>
</button>
